import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {WidgetsService} from 'src/app/services/widgets.service';
import * as NpsActions from './nps.actions';
import {catchError, map, switchMap, withLatestFrom, filter, tap} from 'rxjs/operators';
import {EMPTY, mergeMap, of} from 'rxjs';
import {Store} from '@ngrx/store';
import {NpsStateMap} from './nps.reducer';
import {isEqual} from "lodash";

@Injectable()
export class NpsEffects {
    constructor(
        private actions$: Actions,
        private widgetsService: WidgetsService,
        private store: Store<{ nps: NpsStateMap }>
    ) {
    }

    loadCurrentNps$ = createEffect(() =>
        this.actions$.pipe(
            ofType(NpsActions.loadCurrentNPS),
            withLatestFrom(this.store.select(state => state.nps)),
            mergeMap(([action, state]) => {
				// Currently not possible to cache. Caching would require a deeper analysis.
				// For example, the "Sales NPS Branding Comparison" screen in Sales Analysis fetches the number of surveys every time
				// it's opened. This is a real-time fetch, and the number of surveys can increase, causing a mismatch with any cached
				// survey count.
				// Similarly, the Interview Summary screen and possibly report downloads rely on fresh data.
				// NPS data can only be cached if it's guaranteed not to change or if new data doesn't impact the result.
				// That requires analysis and an implementation that are out of scope for this release.
				// We're keeping the NgRx setup to demonstrate potential caching points, but caching will be removed here for now.
                // const cachedState = state.states?.[action.key];
                // return 
                //     ? EMPTY // Evita richieste non necessarie
                //     : this.fetchNpsData(action);
						return this.fetchNpsData(action);
            })
        )
    );

    private isPayloadUnchanged(cachedState: any, payload: any): boolean {
        return cachedState?.data && isEqual(payload, cachedState.payload);
    }

    private fetchNpsData(action: any) {
        return this.widgetsService.getCurrentNPSWithTarget(action.payload).pipe(
            map(data => NpsActions.loadCurrentNPSSuccess({
                data,
                key: action.key,
                payload: action.payload
            })),
            catchError(error => of(NpsActions.loadCurrentNPSFailure({error})))
        );
    }


}
